import { ApolloClient, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { HttpLink } from '@apollo/client/link/http';

import ENV from '~/constants/ENV';
import NEXT from '~/constants/NEXT';
import types from '~/generated/types.json';
import createApolloClientCache from '~/helpers/createApolloClientCache';
import { getToken } from '~/helpers/token';

const createApolloClient = (): ApolloClient<unknown> => {
  const authLink = setContext((_, { headers }): Record<string, string> => {
    const tokenObj = getToken();

    return {
      headers: {
        ...headers,
        authorization: tokenObj ? `Bearer ${tokenObj.accessToken}` : '',
      },
    };
  });

  const httpLink = new HttpLink({
    uri: ENV.API_ENDPOINT_GRAPHQL,
  });

  const link = ApolloLink.from([authLink, httpLink]);

  return new ApolloClient({
    cache: createApolloClientCache({
      generatedGraphqlPossibleTypes: types.possibleTypes,
    }),
    connectToDevTools: !NEXT.IS_SERVER,
    link,
    ssrMode: NEXT.IS_SERVER,
  });
};

export default createApolloClient;
